export function collectMenuIds(item) {
    let ids = [item.category_id];

    if (item.children && item.children.length > 0) {
        item.children.forEach((child) => {
            ids = [
                ...ids,
                ...collectMenuIds(child),
            ];
        });
    }

    return ids;
}